var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:{
        'loading--fullscreen':_vm.mode == 'fullscreen',
        'loading--full':_vm.mode == 'full',
        'loading--absolute':_vm.mode == 'absolute',
        'loading':_vm.mode == 'normal',
        'loading--mask':_vm.mask
    },style:(_vm.wrapStyleObject)},[_c('span',{staticClass:"loading__box"},[_c('i',{staticClass:"loading__icon",style:({
                    'width':_vm.size + 'px',
                    'height':_vm.size + 'px',
                    'border-color':_vm.color,
                    'border-right-color':'transparent'
                })}),(_vm.title)?_c('em',{staticClass:"loading__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }